export default "__VITE_ASSET__07cd9756__"